module.exports = __webpack_public_path__ + "static/media/gerd-icon@3x.09418ea5.png";